import{prefixValue as r,prefixProperty as t}from"tiny-css-prefixer";var e=function(e,i){var o=e+": "+i+";",m=e+": "+(i=r(e,i))+";",n=t(e);return 1&n&&(m+="-ms-"+o),2&n&&(m+="-moz-"+o),4&n&&(m+="-webkit-"+o),m};export{e as prefix};
//# sourceMappingURL=goober-autoprefixer.module.js.map
